/*
 * Send a GET request to the given URL in JSON content type
 * @trackUrl: URL
 *
 * Returns: void
 */
export async function fetchJson(trackUrl) {
  const options = {
    method: "get",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    }
  }
  fetch(trackUrl, options)
}
